import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { List } from 'immutable';
import { Subject } from 'rxjs';
import { DialogActionsEnum, IDialogTrigger } from '../../../dialog/dialog.data';
import { DialogService } from '../../../dialog/dialog.service';
import { filter, takeUntil } from 'rxjs/operators';

export const DIALOG_TYPE = 'view-reminders';

@Component({
  selector: 'app-view-reminders-dialog',
  templateUrl: './view-reminders-dialog.component.html',
  styleUrls: ['./view-reminders-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ViewRemindersDialogComponent implements OnInit, OnDestroy {
  @Output()
  onSendRemindersPreview: EventEmitter<void> = new EventEmitter<void>();

  private _destroyed: Subject<boolean> = new Subject<boolean>();

  schedule: List<number>;
  headerLabel: string;
  dialogType: string;

  constructor(
    private _dialogService: DialogService,
    private _changeDetectorRef: ChangeDetectorRef
  ) {}

  ngOnInit() {
    this.dialogType = DIALOG_TYPE;

    this._dialogService.dialogTriggers$
      .pipe(
        filter((dialogTrigger: IDialogTrigger) => {
          return (
            dialogTrigger.type === this.dialogType &&
            dialogTrigger.action === DialogActionsEnum.open
          );
        }),
        takeUntil(this._destroyed)
      )
      .subscribe((dialogTrigger: IDialogTrigger) => {
        const dialogData = dialogTrigger.data;

        this.schedule = dialogData.schedule;
        this.headerLabel = dialogData.headerLabel;

        this._changeDetectorRef.markForCheck();
        this._changeDetectorRef.detectChanges();
      });
  }

  sendRemindersPreview() {
    this.onSendRemindersPreview.emit();
  }

  ngOnDestroy() {
    this._destroyed.next(true);
    this._destroyed.unsubscribe();
  }
}
